import { useAmplitudeTracker } from '@geovelo-frontends/commons';
import { useContext } from 'react';

import { AppContext } from '../context';

function useTracker() {
  const {
    user: { current: currentUser },
  } = useContext(AppContext);
  const { trackEvent: _trackEvent } = useAmplitudeTracker();

  function trackEvent(
    name: 'Page Visited' | string,
    properties?: Record<string, string | boolean | undefined>,
  ) {
    _trackEvent(name, {
      pathname: `${window.location.host}${window.location.pathname}`,
      user_id: currentUser?.id,
      ...properties,
    });
  }

  return { trackEvent };
}

export default useTracker;
